import TemplateContents from './TemplateContents';
import {gsap} from "gsap";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
    this.getImgLength();
    this.setModal();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
    this.currentIndex = 0;
    this.currentImgIndex = 0;
    this.length = 0;
    this.imgLength = 0;
  }

  setDom() {
    super.setDom();

    this.productsModalDom = document.querySelector('main.top .products_modal');
    this.productsModalInner = document.querySelector('main.top .products_modal .products_modal_inner');
    this.productModalBG = document.querySelector('main.top .products_modal .products_modal_bg');
    this.prevBtn = document.querySelector('main.top .products_modal .ui_modal .prev');
    this.nextBtn = document.querySelector('main.top .products_modal .ui_modal .next');
    this.closeBtn = document.querySelector('main.top .products_modal .ui_modal .close');

    this.nextImgBtn = document.querySelector('main.top .products_modal .left .main .ui_img_slide .c_m_next');
    this.prevImgBtn = document.querySelector('main.top .products_modal .left .main .ui_img_slide .c_m_prev');

    this.photoListContainer = document.querySelector('main.top .products_modal .left .main .photo_list_container');
    this.photoLists = document.querySelectorAll('main.top .products_modal .left .main .photo_list');
    this.thumbsContainer = document.querySelector('main.top .products_modal .left .thumbs .thumb_list_container');
    this.thumbs = document.querySelectorAll('main.top .products_modal .left .thumbs .thumb_list');

    this.rightDom = document.querySelector('main.top .products_modal .right');
    this.rightContents = document.querySelector('main.top .products_modal .right .contents');
    this.rightContentsItems = document.querySelectorAll('main.top .products_modal .right .contents .item');
    
    this.purchaseAnchors = document.querySelectorAll('main.top .products_modal .right .contents .item .btn a');

    this.length = this.rightContentsItems.length;
  }

  initEvents() {
    super.initEvents();

    this.productModalBG.addEventListener('click', this.closeModal.bind(this));

    // タッチデバイスでの反応速度向上とマウス操作の両立を行うヘルパー
    const addTouchClick = (target, handler) => {
      target.addEventListener('touchstart', (e) => {
        if (e.cancelable) e.preventDefault(); // タッチ時は即実行し、後のclick発火を防ぐ
        handler(e);
      }, { passive: false });
      target.addEventListener('click', handler); // マウス操作用
    };

    addTouchClick(this.closeBtn, this.closeModal.bind(this));
    addTouchClick(this.nextBtn, this.next.bind(this));
    addTouchClick(this.prevBtn, this.prev.bind(this));
    addTouchClick(this.nextImgBtn, this.nextImg.bind(this));
    addTouchClick(this.prevImgBtn, this.prevImg.bind(this));

    this.pack.applyIconHoverEffect(this.closeBtn, this.closeBtn.querySelector('span'));
    this.pack.applyIconHoverEffect(this.nextBtn, this.nextBtn.querySelector('span'));
    this.pack.applyIconHoverEffect(this.prevBtn, this.prevBtn.querySelector('span'));
    this.pack.applyIconHoverEffect(this.nextImgBtn, this.nextImgBtn);
    this.pack.applyIconHoverEffect(this.prevImgBtn, this.prevImgBtn);

    this.prevImgBtn.addEventListener('mousedown', ()=>{
      this.pack.commonClick(this.prevImgBtn);
    });
    this.prevImgBtn.addEventListener('touchstart', ()=>{
      this.pack.commonClick(this.prevImgBtn);
    });

    this.nextImgBtn.addEventListener('mousedown', ()=>{
      this.pack.commonClick(this.nextImgBtn);
    });
    this.nextImgBtn.addEventListener('touchstart', ()=>{
      this.pack.commonClick(this.nextImgBtn);
    });

    if(!this.pack.hasTouch){
      this.purchaseAnchors.forEach((anchor) => {
        // this.pack.applyIconHoverEffect(anchor, anchor);
        anchor.addEventListener('mouseover', (event) => {
          this.pack.commonMouseOver(anchor);
        });

        anchor.addEventListener('mouseout', (event) => {
          this.pack.commonMouseOut(anchor);
        });
      });
    }

    for( let i = 0, len = this.thumbs.length; i < len; i++ ){
      let thumbs = this.thumbs[i];
      let thumbAll = thumbs.querySelectorAll('li');
      for( let j = 0, len2 = thumbAll.length; j < len2; j++ ){
        let thumb = thumbAll[j];
        thumb.addEventListener('click', (event)=>{
          this.currentImgIndex = j;
          this.updateImgSlide();
        });
      }
    }
  }

  setModal(){
    for( let i = 0, len = this.rightContentsItems.length; i < len; i++ ){
      let item = this.rightContentsItems[i];
      let btn = item.querySelector('.btn a, .btn a:visited, .btn .no_link');
      let obj = this.pack.productList[i];
      let keyColor = obj.key_color;
      if(obj.text_color === 'black') {
        item.classList.add('black');
      }

      item.style.backgroundColor = keyColor;
      btn.style.color = keyColor;
    }
  }

  openModal(id){
    this.currentIndex = id;
    this.currentImgIndex = 0;
    this.setColor();
    this.resetScroll(0);
    this.productsModalDom.classList.add('active');

    this.pack.common.lockScroll = true;
    if (this.sw < this.pack.BP) document.documentElement.classList.add('lock');
    requestAnimationFrame( ()=>{
      this.updateSlide(true);
      this.productsModalDom.classList.add('open');
      this.pack.top.hero.pause();
    })

  }

  closeModal(event){
    this.productsModalDom.classList.remove('open');

    gsap.delayedCall(.5, ()=>{
      this.productsModalDom.classList.remove('active');
      this.pack.common.lockScroll = false;
      if (this.sw < this.pack.BP) document.documentElement.classList.remove('lock');
    });

    this.pack.top.hero.resume();
  }

  next(event){
    this.currentIndex++;
    this.currentImgIndex = 0;
    if(this.currentIndex > this.length - 1) this.currentIndex = 0;
    this.updateSlide();
    this.setColor();
    this.resetScroll();

  }

  prev(event){
    this.currentIndex--;
    this.currentImgIndex = 0;
    if(this.currentIndex < 0) this.currentIndex = this.length  - 1;
    this.updateSlide();
    this.setColor();
    this.resetScroll();
  }
  
  nextImg(event){
    this.currentImgIndex++;

      if(this.currentImgIndex > this.imgLength - 1) this.currentImgIndex = 0;
      this.updateImgSlide();
  }
  
  prevImg(event){
    this.currentImgIndex--;

    if(this.currentImgIndex < 0) this.currentImgIndex = this.imgLength - 1;
    this.updateImgSlide();
   }

  resetScroll(duration = 0.5) {
    if (this.productsModalInner) {
      gsap.to(this.productsModalInner, {
        scrollTop: 0,
        duration: duration,
        ease: "quart.inOut",
        overwrite: true
      });
    }
  }

  setColor(){
    let colorObj = this.pack.productList[this.currentIndex];
    let textColor = colorObj.text_color;
    let keyColor = colorObj.key_color;

    if(textColor === 'black') this.productsModalDom.classList.add('black');
    else this.productsModalDom.classList.remove('black');

    if(this.sw < this.pack.BP){
      this.prevBtn.style.backgroundColor = keyColor;
      this.nextBtn.style.backgroundColor = keyColor;
      this.closeBtn.style.backgroundColor = keyColor;
    }
  }

  resetLeft(){
    //thumb
    let ul = this.thumbs[this.currentIndex];
    let items = ul.querySelectorAll('li');
    for( let i = 0, len = items.length; i < len; i++ ){
      let thumb = items[i];
      thumb.classList.remove('current');
    }
    items[this.currentImgIndex].classList.add('current');
    ul.style.transform = `translate3d(0, 0, 0)`;

    //photo
    this.photoLists[this.currentIndex].classList.add('no_duration');
    this.photoLists[this.currentIndex].style.transform = `translate3d(0, 0, 0)`;
  }

  updateRightContentsItem(is_no_duration){
    const item = this.rightContentsItems[0];

    // 100%ずつ移動させる
    const x = 100 * this.currentIndex * -1;
    if(is_no_duration){
      this.rightContents.classList.add('no_duration');
    }else{
      this.rightContents.classList.remove('no_duration');
    }
    this.rightContents.style.transform = `translate3d(${x}%, 0, 0)`;
  }

  updateThumbsItem(){
    let ul = this.thumbs[this.currentIndex];
    let items = ul.querySelectorAll('li');
    const item = items[0];
    const style = window.getComputedStyle(item);
    const marginRight = parseFloat(style.marginRight); // マージンを取得
    const width = item.offsetWidth; // 幅を取得

    const unitWidth = width + marginRight;
    const allWidth = unitWidth * this.imgLength;

    // (幅 + マージン) * インデックス 分だけ移動させる
    let x = unitWidth * this.currentImgIndex * -1;
    let minX = ul.offsetWidth - allWidth - marginRight;
    if(minX > 0) minX = 0;

    for( let i = 0, len = items.length; i < len; i++ ){
      let thumb = items[i];
      thumb.classList.remove('current');
    }
    items[this.currentImgIndex].classList.add('current');

    if(x < minX) ul.style.transform = `translate3d(${minX}px, 0, 0)`;
    else ul.style.transform = `translate3d(${x}px, 0, 0)`;
  }

  // スライド位置を更新
  updateSlide(is_no_duration) {
    if (this.length > 0) {
      this.getImgLength();
      this.resetLeft();
      this.updateRightContentsItem(is_no_duration);
      const per = 100 * this.currentIndex * -1;
      if(is_no_duration){
        this.photoListContainer.classList.add('no_duration');
        this.thumbsContainer.classList.add('no_duration');
      }else{
        this.photoListContainer.classList.remove('no_duration');
        this.thumbsContainer.classList.remove('no_duration');
      }
      this.photoListContainer.style.transform = `translate3d(${per}%, 0, 0)`;
      this.thumbsContainer.style.transform = `translate3d(${per}%, 0, 0)`;
    }
  }

  updateImgSlide(is_no_duration){
    if (this.imgLength > 0) {
      this.updateThumbsItem();
      const per = 100 * this.currentImgIndex * -1;
      this.photoLists[this.currentIndex].classList.remove('no_duration');
      this.photoLists[this.currentIndex].style.transform = `translate3d(${per}%, 0, 0)`;
    }
  }

  getImgLength(){
    this.imgLength = this.photoLists[this.currentIndex].querySelectorAll('li').length;
  }
  
  start() {}

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
    this.updateSlide(true);
  }
}
